/**
 * Shared constants for analytics event logging.
 *//**
 * Prefix automatically prepended to all interaction event names.
 * All logging paths (useInteractionLogger, logInteractionEvent, useImpression)
 * apply this prefix with a startsWith guard to prevent double-prefixing.
 */export const EVENT_NAME_PREFIX='midjen.';